import { useState } from 'react'
import { db } from '@/runtime'
import { META } from '@/db/schema'
import { PRIME_APP } from '@/lib/appMode'
import { Button, Field } from './ui'

/** Entered once; stored in Dexie meta. */
export const TokenScreen = ({ onSaved }: { onSaved: () => void }) => {
  const [token, setToken] = useState('')
  const [name, setName] = useState(() =>
    PRIME_APP
      ? 'Prime'
      : typeof navigator !== 'undefined' && /iPhone|Android/.test(navigator.userAgent)
        ? 'Phone'
        : 'Laptop',
  )
  const save = async () => {
    await db.setMeta(META.token, token.trim())
    await db.setMeta(META.deviceName, name.trim())
    onSaved()
  }
  return (
    <main className="min-h-dvh flex items-center justify-center p-6">
      <form
        className="w-full max-w-sm"
        onSubmit={(e) => {
          e.preventDefault()
          void save()
        }}
      >
        <h1 className="text-2xl font-semibold mb-1">{PRIME_APP ? 'Prime' : 'alfieOS'}</h1>
        <p className="text-sm text-muted mb-6">
          Paste the server token, or the invitation someone sent you, to connect this device.
        </p>
        <Field label="Token or invitation">
          <input
            value={token}
            onChange={(e) => setToken(e.target.value)}
            className="w-full font-mono"
            autoFocus
            autoComplete="off"
            data-testid="token-input"
          />
        </Field>
        <Field label="This device">
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full"
            data-testid="device-input"
          />
        </Field>
        {/* not ready: a plain button, not a dimmed accent (dark on slate read as neither) */}
        <Button
          variant={token.trim().length < 32 ? 'ghost' : 'primary'}
          big
          className="w-full disabled:opacity-60"
          type="submit"
          disabled={token.trim().length < 32}
          data-testid="token-submit"
        >
          Connect
        </Button>
      </form>
    </main>
  )
}
